import { getAvailableResolutions } from "../lib/resolutions.lib";
import type { OrderLineItem, Resolution } from "../types";
import { usePublicShop } from "../queries/use-public-shop";

export function useAvailableResolutions(
  shopId: string,
  lineItem: OrderLineItem,
): Resolution[] {
  const { data: shop } = usePublicShop(shopId);
  return getAvailableResolutions(shop, lineItem);
}
